export default __webpack_public_path__ + "media/images/react_icons/move_in-b68f5c05d576037efc51486d050571cf.svg";